import axios from 'axios'
import { session, cookie } from '@/libs/location'
import { handleCode } from '@/libs/unusual'

// 自定义判断元素类型JS
function toType (obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

// 参数过滤函数
function filterNull (o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
      if (o[key].length === 0) {
        delete o[key]
      }
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
      if (o[key].length === 0) {
        delete o[key]
      }
    }
  }
  return o
}

// axios 全局变量 //
// axios.defaults.baseURL = baseUrl
// axios.defaults.timeout = 5000
// axios.defaults.withCredentials = true // 让ajax携带cookie
console.log(session)

let car = ['dlcd.dolinkhub.com']
let cookieName = ''
if (car.indexOf(window.location.host) !== -1) {
  cookieName = `token${window.document.location.href.split('/')[3]}`
} else {
  cookieName = 'token'
}
// 请求拦截器
axios.interceptors.request.use(function (config) {
  let token = cookie.getCookie(cookieName)
  config.headers.common['authorization'] = token === null ? '' : token
  config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  return config
}, function (error) {
  return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use(function (response) {
  let status = response.data.status
  let code = response.data.code
  let msg = response.data.message
  if (status === 'success') {
  } else {
    if (msg && msg !== 'OK') {
      handleCode(code, msg)
    }
  }
  return response
}, function (error) {
  handleCode('404', '')
  return Promise.reject(error)
})

export const request = {
  get: function (url, data) {
    if (data) {
      data = filterNull(data)
    }
    let config = {
      method: 'get',
      url: url,
      params: data || {/* get请求参数 */}
    }
    return axios(config)
  },
  post: function (url, data) {
    if (data) {
      data = filterNull(data)
    }
    let config = {
      method: 'post',
      url: url,
      data: data || {/* post请求参数 */}
    }
    return axios(config)
  },
  multipleRequest: function (requests) {
    let reqArray = []
    if (requests.length > 0) {
      for (let req of requests) {
        if (req.method === 'GET') {
          reqArray.push(axios.get(req.url, { params: req.data }))
        } else if (req.method === 'POST') {
          reqArray.push(axios.post(req.url, req.data))
        }
      }
      return axios.all(reqArray)
    }
  }
}
